module.exports = __webpack_public_path__ + "img/why-us-b.8844f5c8.svg";